import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconXCircle = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-xcircle" data-icon="icon-xcircle" aria-hidden="true" {...props} ref={ref}><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>);
});

IconXCircle.displayName = 'IconXCircle';
